import React, { useState, useEffect, useCallback } from 'react';
import { requestExpenses } from '../../../actions/ExpensesActions.js';
import ExpenseDetails from '../../expenses/components/ExpenseDetails.js';
import NoEntriesFound from '../../components/NoEntriesFound.js';
import DetailsLoading from '../../components/DetailsLoading.js';
import { connect } from 'react-redux';
import * as expensesSelectors from '../../../selectors/ExpensesSelectors.js';

const UnsyncedExpenseEntriesTable = ({
    entriesByWeek,
    sortedWeekIds,
    weeklyTotals,
    weeklyGrandTotal,
    loading,
    requestExpenses,
}) => {
    useEffect(() => {
        requestExpenses({
            showLoading: true,
            queryParams: {
                exported: 'No',
                approved: 'Yes',
                search_end_date: '',
                search_start_date: '',
            },
        });
    }, []);

    if (loading) return <DetailsLoading description="Loading Expenses" />;

    return (
        <ExpenseDetails
            entriesByWeek={entriesByWeek}
            weekIds={sortedWeekIds}
            weeklyTotals={weeklyTotals}
            weeklyGrandTotal={weeklyGrandTotal}
            entriesAvailableForEdit={[]}
            selectedEntryIds={[]}
            readOnly
        />
    );
};

const mapStateToProps = state => {
    return {
        entriesByWeek: expensesSelectors.selectGroupedByWeekAndVendor(state),
        sortedWeekIds: expensesSelectors.selectSortedWeekIds(state),
        weeklyTotals: expensesSelectors.selectWeeklyTotals(state),
        weeklyGrandTotal: expensesSelectors.selectWeeklyGrandTotal(state),
        loading: state.expensesStore.loading,
    };
};

const mapDispatchToProps = {
    requestExpenses,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UnsyncedExpenseEntriesTable);
